var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "box",
      staticStyle: { padding: "20px" },
      attrs: { id: "new-group" }
    },
    [
      _c("vue-loading", {
        attrs: {
          active: _vm.isSaving,
          "is-full-page": true,
          loader: "dots",
          color: "#70A1F0"
        },
        on: {
          "update:active": function($event) {
            _vm.isSaving = $event
          }
        }
      }),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade", appear: "" } }, [
        _c("div", [
          _c("h4", [_vm._v("Delete " + _vm._s(_vm.id) + " Group")]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-danger",
              on: {
                click: function($event) {
                  return _vm.delGroup()
                }
              }
            },
            [_vm._v("Delete Group")]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-84646080", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84646080","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/GroupDelete.vue
// module id = null
// module chunks = 